import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Key16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_367)'>
      <path
        d='M5.00001 5.5C5.5523 5.5 6.00001 5.05228 6.00001 4.5C6.00001 3.94772 5.5523 3.5 5.00001 3.5C4.44773 3.5 4.00001 3.94772 4.00001 4.5C4.00001 5.05228 4.44773 5.5 5.00001 5.5Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2.13807 1.64124C0.283079 3.49623 0.283079 6.50377 2.13807 8.35876C3.06542 9.28611 4.28236 9.75 5.49683 9.75H6.68617L8.24683 11.3107V12.5C8.24683 13.1904 8.80648 13.75 9.49683 13.75L10.2468 13.75V14.5C10.2468 15.1904 10.8065 15.75 11.4968 15.75L14.4999 15.75C15.1903 15.75 15.7499 15.1904 15.7499 14.5V12.2072C15.7499 11.8755 15.6182 11.5575 15.3836 11.3231L10.2468 6.18922V5C10.2468 3.78553 9.78293 2.56859 8.85558 1.64124C7.00059 -0.213748 3.99306 -0.213748 2.13807 1.64124ZM3.19873 7.2981C1.92953 6.02889 1.92953 3.97111 3.19873 2.7019C4.46793 1.4327 6.52572 1.4327 7.79492 2.7019C8.42967 3.33665 8.74683 4.16709 8.74683 5V6.29281C8.74683 6.62445 8.87862 6.9425 9.11319 7.17694L14.2499 12.3108L14.2499 14.25H11.7468V13.5C11.7468 12.8096 11.1872 12.25 10.4968 12.25L9.74683 12.25V11.2071C9.74683 10.8756 9.61514 10.5576 9.38072 10.3232L7.67361 8.61612C7.43919 8.3817 7.12125 8.25 6.78973 8.25H5.49683C4.66392 8.25 3.83348 7.93285 3.19873 7.2981Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_367'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Key16.displayName = 'Key16';
export default Key16;
